import {
    EventButtonClick,
    EventScreenView,
    PropBaseEventProps,
    PropBaseEventPropsV2,
} from '@calm/evexia-analytics';
import isSSR from '@calm/web-common/dist/isSSR';

type EventBaseProps =
    | PropBaseEventProps
    | PropBaseEventPropsV2
    | EventButtonClick
    | EventScreenView;

export default function mapBaseEventProps<T extends EventBaseProps>(
    properties?: T
): T {
    return {
        ...properties,
        ScreenWidth: isSSR() ? 0 : window.innerWidth,
        ScreenHeight: isSSR() ? 0 : window.innerHeight,
        CurrentUrlPath: isSSR() ? '' : window.location.pathname,
        CurrentUrlDomain: isSSR() ? '' : window.location.origin,
    } as T;
}
